<template>
  <v-dialog v-model="dialog" scrollable max-width="960">
    <template v-slot:activator="{ }">
      <v-btn icon color="primary" :loading="cargando" :disabled="disabled" @click="abrirDescripcion()"
             class="inline-block">
        <v-img :src="require('../../../assets/iconos/info.png')" contain height="30"/>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="primary white--text">
        {{ $t("descrip", [nombre]) }}
      </v-card-title>

      <v-card-text class="pt-2">
        <span v-html="descripcion"/>
      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="error" text @click="dialog = false">
          {{ $t("cerrar") | capitalize }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import "@/comunes/servicios/DescripcionesCeramicaServicio";

export default {
  name: "BtnDescripcion",
  props: {
    id: {required: true, type: Number},
    id_proyecto: {required: true, type: Number},
    disabled: {type: Boolean, default: false}
  },
  data: () => ({
    dialog: false,
    cargando: false,
    nombre: "",
    descripcion: ""
  }),
  methods: {
    abrirDescripcion() {
      this.cargando = true;

      HttpHelper.get(`solucion-constructiva/${this.id}/descripcion`)
          .then(async (res) => {
            this.nombre = res.nombre;
            this.descripcion = await window.DescripcionesCeramica.generar(this.id_proyecto, this.id, res.contenido);
            this.dialog = true;
          })
          .finally(() => {
            this.cargando = false;
          });
    }
  }
}
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "descrip": "Descripción de la solución constructiva: {0}"
  }
}
</i18n>
<!--@formatter:on-->